import { PAGE_SIZE } from "@/utils/constants";
import axios from "axios";
import PaginationData from "./../../general/PaginationData";
import EmployeeBranchesFilter from "./EmployeeBranchesFilter";

export default class EmployeeBranch {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.employeeBranchesToken = "";
    this.employeeBranchesCode = "";
    this.employeeToken = "";
    this.employeeNameCurrent = "";
    this.branchToken = "";
    this.branchNameCurrent = "";
    this.branchNameAr = "";
    this.branchNameEn = "";
    this.branchRoleToken = "";
    this.branchRoleNameCurrent = "";
    this.employeeWorkPlaceTypeToken = "";
    this.employeeWorkPlaceTypeNameCurrent = "";
    this.employeeWorkPlaceTypeNameEn = "";
    this.employeeWorkPlaceTypeNameAr = "";
    this.employeeWorkPlaceTypeNameUnd = "";
    this.employeeBranchesNotes = "";
    this.actionDateTime = "";
    this.actionDate = "";
    this.actionTime = "";
    this.employeeBranchesArchiveStatus = "";
    this.employeeBranchJobsData = [];
    this.jobsTokenList = [];
    this.employeesList = [];
  }
  fillData(data) {
    this.employeeBranchesToken = data.employeeBranchesToken;
    this.employeeBranchesCode = data.employeeBranchesCode;
    this.employeeToken = data.employeeToken;
    this.employeeNameCurrent = data.employeeNameCurrent;
    this.branchToken = data.branchToken;
    this.branchNameCurrent = data.branchNameCurrent;
    this.branchNameAr = data.branchNameAr;
    this.branchNameEn = data.branchNameEn;
    this.branchRoleToken = data.branchRoleToken;
    this.branchRoleNameCurrent = data.branchRoleNameCurrent;
    this.employeeWorkPlaceTypeToken = data.employeeWorkPlaceTypeToken;
    this.employeeWorkPlaceTypeNameCurrent =
      data.employeeWorkPlaceTypeNameCurrent;
    this.employeeWorkPlaceTypeNameEn = data.employeeWorkPlaceTypeNameEn;
    this.employeeWorkPlaceTypeNameAr = data.employeeWorkPlaceTypeNameAr;
    this.employeeWorkPlaceTypeNameUnd = data.employeeWorkPlaceTypeNameUnd;
    this.employeeBranchesNotes = data.employeeBranchesNotes;
    this.actionDateTime = data.actionDateTime;
    this.actionDate = data.actionDate;
    this.actionTime = data.actionTime;
    this.employeeBranchesArchiveStatus = data.employeeBranchesArchiveStatus;
    this.employeeBranchJobsData = data.employeeBranchJobsData;
    this.jobsTokenList = data.jobsTokenList;
  }

  async getAllEmployeeBranches(
    language,
    userAuthorizeToken,
    pagination = new PaginationData(),
    filterData = new EmployeeBranchesFilter()
  ) {
    try {
      return await axios.get(
        `/EmployeeBranches/GetAllEmployeeBranches?language=${language}&userAuthorizeToken=${userAuthorizeToken}&page=${pagination.selfPage}&paginationStatus=&pageSize=${PAGE_SIZE}&filterStatus=true&branchToken=${filterData.branchToken}&employeeToken=${filterData.employeeToken}&branchRoleToken=${filterData.branchRoleToken}&textSearch=${filterData.textSearch}`
      );
    } catch (error) {
      return this.$t("errorCatch");
    }
  }

  async getEmployeeBranchesDetails(language, userAuthorizeToken) {
    try {
      let response = await axios.get(
        `/EmployeeBranches/GetEmployeeBranchesDetails?language=${language}&userAuthorizeToken=${userAuthorizeToken}&employeeBranchesToken=${this.employeeBranchesToken}`
      );
      return response;
    } catch (error) {
      return this.$t("errorCatch");
    }
  }

  async addEmployeeBranches(language, userAuthorizeToken) {
    var data = {
      language: language,
      userAuthorizeToken: userAuthorizeToken,
      employeeBranchesCode: this.employeeBranchesCode, // not exist in Form, because not necessary
      branchToken: this.branchToken,
      branchRoleToken: this.branchRoleToken,
      employeeBranchesNotes: this.employeeBranchesNotes,
      employeeWorkPlaceTypeToken: this.employeeWorkPlaceTypeToken,
      employeesList: this.employeesList,
    };

    try {
      let response = await axios.post(
        `/EmployeeBranches/AddEmployeeBranches`,
        data
      );
      return response;
    } catch (e) {
      return this.$t("errorCatch");
    }
  }

  async updateEmployeeBranch(language, userAuthorizeToken) {
    var data = {
      language: language,
      userAuthorizeToken: userAuthorizeToken,
      employeeBranchesToken: this.employeeBranchesToken,
      employeeWorkPlaceTypeToken: this.employeeWorkPlaceTypeToken,
      branchRoleToken: this.branchRoleToken,
      employeeBranchesNotes: this.employeeBranchesNotes,
      jobsTokenList: this.jobsTokenList,
    };

    try {
      let response = await axios.post(
        `/EmployeeBranches/UpdateEmployeeBranches`,
        data
      );
      return response;
    } catch (e) {
      return this.$t("errorCatch");
    }
  }

  async finalDeleteEmployeeBranch(language, userAuthorizeToken) {
    var data = {
      language: language,
      userAuthorizeToken: userAuthorizeToken,
      employeeBranchesToken: this.employeeBranchesToken,
    };

    try {
      let response = await axios.post(
        `/EmployeeBranches/FinalDeleteEmployeeBranches`,
        data
      );
      return response;
    } catch (e) {
      return this.$t("errorCatch");
    }
  }
}
